import { render, staticRenderFns } from "./LogisticConfigurationSelector.vue?vue&type=template&id=242103bf&"
import script from "./LogisticConfigurationSelector.vue?vue&type=script&lang=js&"
export * from "./LogisticConfigurationSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports